import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../../theme';
import Button from '../../components/button';

interface Props {
  title: string;
  description: string;
  Image: React.FC<any>
  buttonText?: string;
  onClick?: (e: any) => void;
  /** 'row' (default) places the image beside the copy on larger screens. 'column' always
   * stacks the image on top with the copy centered underneath. */
  layout?: 'row' | 'column';
  /** When true (row layout only), groups the image and copy together and centers that group
   * in the container instead of spreading them apart with `space-around`. */
  centerContent?: boolean;
  /** Background color of the container. Defaults to the theme's paper (white) background. */
  background?: string;
}

const OnboardingEmpty: React.FC<Props> = ({
  title,
  Image,
  description,
  onClick,
  buttonText,
  layout = 'row',
  centerContent = false,
  background = theme.palette.background.paper,
}) => {
  const largerScreen = useMediaQuery('(min-width:1087px)') && layout === 'row';
  const justifyContent = layout === 'column' || centerContent ? 'center' : 'space-around';
  return (
    <Box
      display="flex"
      flexDirection={layout === 'column' ? 'column' : 'row'}
      alignItems="center"
      justifyContent={justifyContent}
      gap={centerContent ? 6 : undefined}
      sx={{ background }}
      minHeight="484px"
      height="fit-content"
      flexWrap="wrap"
      p={5}
    >
      {layout === 'column' ? (
        <Box width="100%" maxWidth="360px">
          <Image width="100%" />
        </Box>
      ) : (
        <Image width="100%" />
      )}
      <Box
        display="flex"
        flexDirection="column"
        alignItems={largerScreen ? 'start' : 'center'}
        justifyContent={largerScreen ? 'space-around' : 'start'}
        width={largerScreen ? '50%' : '100%'}
        textAlign={largerScreen ? 'left' : 'center'}
        mt={layout === 'column' ? 3 : 0}
      >
        <Typography variant={largerScreen ? 'h1' : 'h4'}>
          {title}
        </Typography>
        <Typography variant="body1" mt={1} sx={{ opacity: 0.5 }}>
          {description}
        </Typography>
        {buttonText && (
          <Button sx={{ mt: 1 }} variant="outlined" onClick={onClick}>
            {buttonText}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default OnboardingEmpty;
